import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  //base: '/peetsweb-dev/',
  base: '/',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/view/HomePage'], resolve),
      meta: {
        title: '皮氏咖啡企业官网 We Put Coffee First',
        type: 'cn'
      }
    },
    {
      path: '/news/newsdetail',
      name: 'newsdetail',
      component: resolve => require(['@/view/Newsdetail'], resolve),
      meta: {
        title: '皮氏咖啡企业官网 We Put Coffee First',
        type: 'cn'
      }
    },
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['@/view/Product'], resolve),
      meta: {
        title: '我们的产品',
        type: 'cn'
      }
    },
    {
      path: '/brand',
      name: 'brand',
      component: resolve => require(['@/view/Brand'], resolve),
      meta: {
        title: '我们的品牌',
        type: 'cn'
      }
    },
    {
      path: '/college',
      name: 'college',
      component: resolve => require(['@/view/College'], resolve),
      meta: {
        title: '咖啡学院',
        type: 'cn'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: resolve => require(['@/view/Joinus'], resolve),
      meta: {
        title: '专业咖啡服务',
        type: 'cn'
      }
    },
    {
      path: '/store',
      name: 'store',
      component: resolve => require(['@/view/Store'], resolve),
      meta: {
        title: '我们的门店',
        type: 'cn'
      }
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: resolve => require(['@/view/Joinus'], resolve),
      meta: {
        title: '加入我们',
        type: 'cn'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js